var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.name !== 'loading')?_c('AppBar'):_vm._e(),_c('Content'),(this.$route.name !== 'loading')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }